import('./bootstrap').catch((err) => console.error('Error loading bootstrap:', err))
